var components = require("../components");
var utils = require("../shared/utils");
var $ = require("jquery");
var SPScript = require("spscript");

SPScript.utils.waitForLibrary("SP.UI.AspMenu").then(() =>  {
    SP.UI.AspMenu.$18 = function() { return false;};
});


exports.create = function () {
    
    components.footer.create("#natp-footer");
    components.header.create();
    
    
    
    //Try to show breadcrumb on non-system pages
    if (window._natpBreadcrumbEnabled) {
        components.breadcrumb.create("#breadcrumbTrail");
    }
    
    // Add "Publish" button to Breadcrumb Termset
    if (utils.isPage("TermStoreManager.aspx")) {
        components.breadcrumbPublisher.create();
    }
    // components.loginForm.create(".natp-login-container");
};


// WEBPACK FOOTER //
// ./src/scripts/onload/components.js